export default function PHP_ftell() {
  return (
    <div>
      <h1>PHP_ftell</h1>
    </div>
  );
}
